import { Link } from 'react-router-dom';
import { DymoPrinterPanel, LabelDestinationPicker } from '../components/LabelPrinting.js';
import { Card, PageHeader } from '../components/ui.js';
import { LABELING_PATH } from '../lib/nav.js';
import { useLabelDestination } from '../labels/useLabelDestination.js';

/**
 * Label printing (`/settings/labels`): where this browser sends FNSKU labels.
 *
 * The one setting in the app that belongs to the computer, not the account: the
 * bench computer prints to a label roll, the office one to sheets, and the same
 * person uses both. It is kept in this browser's localStorage and is never sent
 * to the server, so any signed-in role may set it. See docs/labels.md.
 */
export function LabelSettingsPage() {
  const [destination, setDestination] = useLabelDestination();

  return (
    <div className="space-y-4">
      <PageHeader
        title="Label printing"
        description="Where this browser sends FNSKU labels when you press Print all labels. The choice is saved on this computer only, so each computer can print to its own printer."
      />

      <Card className="max-w-2xl space-y-4 p-5">
        <LabelDestinationPicker value={destination} onChange={setDestination} />
        <p className="text-xs text-muted">
          Saved in this browser as you choose it. Another browser, or another computer, keeps its
          own choice and starts on sheet labels, 30 per sheet. The first two choices make a PDF and
          open it for your browser to print. The DYMO LabelWriter prints at once, with no dialog,
          and can be chosen only while DYMO Connect reports a connected LabelWriter on this
          computer.
        </p>
        <div className="border-t border-line pt-4">
          <DymoPrinterPanel />
        </div>
        <p className="text-sm">
          <Link
            to={LABELING_PATH}
            className="font-medium text-brand-600 underline underline-offset-2"
          >
            Go to Labeling
          </Link>
        </p>
      </Card>
    </div>
  );
}
